import {
  collection,
  onSnapshot,
  FirestoreError,
  query,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../../../firebase";
import { EntityGet, EntityServerGet, ListServiceOpts } from "../../../types";
import { Systemmessageversion } from "./types";
import { transformMetadata, processTimestampFields } from "../../../utils";

export type SystemmessageversionOnSnapshotCollectionService<T> = (
  agentId: string,
  llmId: string,
  opts: ListServiceOpts,
  callback: (docs: Array<T>) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotCollection: SystemmessageversionOnSnapshotCollectionService<
  EntityGet<Systemmessageversion>
> = (agentId, llmId, opts: ListServiceOpts, callback, onError = () => {}) => {
  const collectionRef = collection(
    db,
    `/agent/${agentId}/llm/${llmId}/systemmessageversion`
  );
  const { disableCache } = opts;
  const q = opts.listQueryFn
    ? opts.listQueryFn(collectionRef)
    : query(collectionRef);
  return onSnapshot(
    q,
    { includeMetadataChanges: disableCache },
    (querySnap) => {
      const { metadata } = querySnap;
      const { fromCache } = metadata;
      if (disableCache && fromCache) return;
      callback(
        querySnap.docs.map(
          (doc) =>
            processTimestampFields(
              transformMetadata(
                {
                  ...doc.data(),
                  id: doc.id,
                } as EntityServerGet<Systemmessageversion>,
                doc.metadata
              )
            ) as EntityGet<Systemmessageversion>
        )
      );
    },
    onError
  );
};

export default onSnapshotCollection;
